module.exports = __webpack_public_path__ + "img/ltktrendingcreators-3x.44c3870.jpg";